import React from 'react';
import Table from './Table';
import CardHeader from '../shared/CardHeader';
import {FluidRatio} from 'components/Ratio';
import styles from './CardTable.css?module';
import ComponentTable from 'components/Table';

const TWO_COLUMN_WIDTH = 199;
const THREE_COLUMN_WIDTH = 568;
const cardWidth = width =>
  width < THREE_COLUMN_WIDTH ? TWO_COLUMN_WIDTH : THREE_COLUMN_WIDTH;

const CardTable = ({card, ...rest}) => (
  <div className={styles.tableVisualization}>
    <CardHeader card={card} />
    <FluidRatio x={2} y={1}>
      {(width, height, hasComputed) => (
        <Table
          {...rest}
          width={width}
          phoenixWidth={cardWidth(width)}
          maxRows={6}
          height={height}
          showHeader={true}
          isResizing={!hasComputed}
          component={ComponentTable}
        />
      )}
    </FluidRatio>
  </div>
);

export default CardTable;
